import { createSelector } from '@reduxjs/toolkit';
import type { GetCustomerSecuritiesRequestParams } from '@src/providers/AppStateProvider/streamingDataSlice';
import type { AppState } from '@src/providers/AppStateProvider/types';

export const selectSalesOrderCustomerSecuritiesRequestParams = createSelector(
  (state: AppState) => state.salesOrder.form.customerField,
  (customerField): Partial<GetCustomerSecuritiesRequestParams> => {
    return {
      Counterparty: customerField.value?.Name,
    };
  }
);
